import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys } from '../../lib/react-query'
import { leakedApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'
import type { LeakedDataApiResponse } from '../../app/modules/types/leaked'



/**
 * Hook for fetching leaked data hosts (databases)
 */
export function useLeakedHosts(page: number = 1) {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()
  return useQuery({
    queryKey: queryKeys.leaked.hosts(orgId, page, params),
    queryFn: () => leakedApi.getHosts(page, params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching leaked data host details
 */
export function useLeakedHostDetail(hostId: string, page: number = 1) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.leaked.hostDetail(orgId, hostId, page),
    queryFn: () => leakedApi.getHostById(hostId, page),
    enabled: !!hostId && !!orgId,
  })
}
